class IgReadyAggregator {
    constructor() {
      console.log('IgReadyAggregator');
      /** @type {boolean} */
      this.isIgReady = false;
      /** @type {Function[]} */
      this.callbackQueue = [];
      window.addEventListener('message', this.onWindowMessage);
      document.addEventListener('DOMContentLoaded', this.onDOMLoaded);
    }
    /**
     * Event listener for the `message` event sent by Intelligems to signal that the
     * `igData` object is ready
     * @this Window
     * @param {MessageEvent} e
     */
    onWindowMessage(e) {
      if (e.data !== 'ig-ready') {
        return;
      }
      console.log('Starting Intelligems...');
      this.removeEventListener('message', this.igReadyAggregator.onWindowMessage);
      this.igReadyAggregator.isIgReady = true;
      if (this.document.readyState === 'loading') {
        return;
      }
      window.igReadyAggregator.invokeCallbacks();
    }
    /**
     * Event listener for the document's `DOMContentLoaded` event
     * @this Document
     * @param {Event} e
     */
    onDOMLoaded(e) {
      if (!window.igReadyAggregator.isIgReady) {
        return;
      }
      window.igReadyAggregator.invokeCallbacks();
    }
    /**
     * This method should be used to queue a function for when Intelligems' igData
     * object is ready for use
     * @param {Function} callback
     */
    addIgReadyListener(callback) {
      // Invoke callback if isIgReady and DOMContentLoaded
      if (this.isIgReady && document.readyState !== 'loading') {
        callback();
        return;
      }
      // Queue callback if waiting for Intelligems or DOMContentLoaded event
      this.callbackQueue.push(callback);
    }
    invokeCallbacks() {
      this.callbackQueue.forEach((cb) => {
        cb();
      });
    }
  }
  window.igReadyAggregator = window.igReadyAggregator || new IgReadyAggregator(); 